import { render, staticRenderFns } from "./CriteriaUsageTable.vue?vue&type=template&id=67af4719&scoped=true"
import script from "./CriteriaUsageTable.vue?vue&type=script&lang=js"
export * from "./CriteriaUsageTable.vue?vue&type=script&lang=js"
import style0 from "./CriteriaUsageTable.vue?vue&type=style&index=0&id=67af4719&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67af4719",
  null
  
)

export default component.exports